import styled from 'styled-components';

export const StyledNoDataMessage = styled.div`
  display: block;
  border-radius: 0;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-style: italic;
  color: ${({ theme }) => theme.colors.darkestGray};
`;

export const StyledErrorMessage = styled.div`
  display: flex;
  border-radius: 0;
  min-height: 40px;
  padding: 8px;
  box-sizing: border-box;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.error};
  background: ${({ theme }) => theme.colors.errorBackground};
`;

export const StyledErrorIcon = styled.svg`
  margin-right: 8px;
  flex-shrink:0 ;
`;
